import ColumnTypes from '@/utils/ColumnTypes';

const file_name = {
	key: 'file_name',
	label: '文件名称',
	type: 'rdText',
	minWidth: '200',
};
const add_time = {
	key: 'add_time',
	label: '操作时间',
	type: 'rdText',
	minWidth: '200',
};
const import_situation = {
	key: 'import_situation',
	label: '导入情况',
	type: () => import('./components/tableCell/importSituation'),
	minWidth: '250',
};
const task_status = {
	key: 'task_status',
	label: '状态',
	type: () => import('./components/tableCell/taskStatus'),
	minWidth: '250',
};

const operations = {
	key: 'operations',
	label: '操作',
	type: ColumnTypes.ButtonsCell,
	minWidth: '100',
	fixed: 'right',
	align: 'right',
};

export const columns = [file_name, add_time, import_situation, task_status, operations];
